import { render } from "./MenuButton.vue?vue&type=template&id=77e85da5&scoped=true"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"

import "./MenuButton.vue?vue&type=style&index=0&id=77e85da5&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e85da5"]])

export default __exports__